export default function trackHDPreference(useHD) {
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'juke-player_hd-audio-switch',
      event_action: 'hd-audio-switch',
      event_category: 'juke-player',
      event_label: useHD || null,
    },
  ]);
}
